import { createSystem, defaultConfig } from '@chakra-ui/react'
import { colourTokens } from './foundations/colours'
import { effectTokens } from './foundations/effects'
import { textStyles, typographyTokens } from './foundations/typography'
import { assiduousButtonRecipe } from './recipes/button'
import { assiduousDialogRecipe } from './recipes/dialog'
import { assiduousSearchBarRecipe } from './recipes/search-bar'
import { assiduousSlideRailRecipe } from './recipes/slide-rail'
import { semanticColourTokens } from './semantic-tokens/colours'

export const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      colors: colourTokens,
      ...effectTokens,
      ...typographyTokens,
    },
    semanticTokens: {
      colors: semanticColourTokens,
    },
    textStyles,
    recipes: {
      assiduousButton: assiduousButtonRecipe,
      assiduousSearchBar: assiduousSearchBarRecipe,
    },
    slotRecipes: {
      assiduousDialog: assiduousDialogRecipe,
      assiduousSlideRail: assiduousSlideRailRecipe,
    },
  },
})
